// Static demo-mode fill-in data for CreateEmployees.component.jsx.
// Shapes must match exactly what the component expects — the Department
// PillDropdown's `options` is Array<{ label, value }> (matches
// useUserTeamsForCompany's `teamOptions` shape), and `selectedCompany` /
// `selectedTeam` are `{ label, value } | null` (matches
// useEmployeePageCompanyTeamUrlSync's JSDoc / useUserCompanies' `companyOptions`).

// Matches the DEMO_PROFILE seeded in Auth.reducer.js
// (activeCompany.companyId 'demo-company', companyName 'Meridian Labs').
export const DEMO_SELECTED_COMPANY = {
  label: 'Meridian Labs',
  value: 'demo-company',
};

// Consumed by the Department PillDropdown (options + default selection).
export const DEMO_TEAM_OPTIONS = [
  { label: 'Engineering', value: 'demo-team-engineering' },
  { label: 'Sales', value: 'demo-team-sales' },
  { label: 'Customer Support', value: 'demo-team-support' },
];
